// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
// import useJwt from '@src/auth/jwt/useJwt'
// const config = useJwt.jwtConfig
// const headers = {
//   token: JSON.parse(localStorage.getItem(config.storageTokenKeyName)),
//   userID: JSON.parse(localStorage.getItem('userID'))
// }

export const updatePersonalProfile = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverPersonalProfile', params, { mode: 'cors' })
     
  return response.data
})
export const getDriverDetail = createAsyncThunk('updatedriver/getDriverDetail', async (GetDriver) => {
 
  const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })
 
  return response.data
})
export const updateAccountProfile = createAsyncThunk('updatedriver/updateAccountProfile ', async (params) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverAccountProfile', params, { mode: 'cors' })
     
  return response.data
})

export const updateDriverSlice = createSlice({
  name: 'updatedriver',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument: [],
    IsSaved: 0,
    IsClosed: false
  },
  reducers: {},
  extraReducers: builder => {
    builder

    .addCase(getDriverDetail.fulfilled, (state, action) => {
                 
      state.data = action.payload.data
  })
  .addCase(updateAccountProfile.fulfilled, (state, action) => {
                 
    state.data = action.payload.data
})
  
  }
})

export default updateDriverSlice.reducer
